'use strict';

var __chunk_2 = require('./chunk-d7703e54.js');
var append = require('./append.js');
var flip = require('./flip.js');

/**
 * Returns a list that contains the elements in the list of `as` concatenated
 * with the starting value `s`.
 *
 * @private
 */

function concatWith(s, as) {
  return Array.from(__chunk_2.flatten(as)).reduce(flip(append), s);
}

exports.concatWith = concatWith;
